interface WaveLineProps {
  width?: number;
  height?: number;
  color?: 'primary' | 'secondary' | 'accent' | 'neutral';
  opacity?: number;
  strokeWidth?: number;
  variant?: 'single' | 'double';
  className?: string;
}

const COLOR_MAP: Record<string, string> = {
  primary: 'var(--color-primary-500)',
  secondary: 'var(--color-secondary-500)',
  accent: '#10B981',
  neutral: '#64748b',
};

export function WaveLine({
  width = 220,
  height = 60,
  color = 'primary',
  opacity = 0.4,
  strokeWidth = 2.5,
  variant = 'single',
  className = '',
}: WaveLineProps) {
  const midY = height / 2;
  const amp = height * 0.35;
  const path = `M 0 ${midY} C ${width * 0.15} ${midY - amp}, ${width * 0.35} ${midY + amp}, ${width * 0.5} ${midY} C ${width * 0.65} ${midY - amp}, ${width * 0.85} ${midY + amp}, ${width} ${midY}`;

  const offsetY = 10;
  const path2 = `M 0 ${midY + offsetY} C ${width * 0.15} ${midY + offsetY - amp * 0.7}, ${width * 0.35} ${midY + offsetY + amp * 0.7}, ${width * 0.5} ${midY + offsetY} C ${width * 0.65} ${midY + offsetY - amp * 0.7}, ${width * 0.85} ${midY + offsetY + amp * 0.7}, ${width} ${midY + offsetY}`;

  return (
    <svg
      width={width}
      height={height + (variant === 'double' ? offsetY : 0)}
      viewBox={`0 0 ${width} ${height + (variant === 'double' ? offsetY : 0)}`}
      fill="none"
      className={className}
      style={{ opacity }}
    >
      <path
        d={path}
        stroke={COLOR_MAP[color]}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        fill="none"
      />
      {variant === 'double' && (
        <path
          d={path2}
          stroke={COLOR_MAP[color]}
          strokeWidth={strokeWidth * 0.6}
          strokeLinecap="round"
          fill="none"
          opacity={0.5}
        />
      )}
    </svg>
  );
}
